import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SetupSearch } from 'areas/shared/pages/setup';
import { SearchBox } from 'fw/forms';
import * as API from 'modules/app/API';
import { EmailCategoryCombo } from 'areas/shared/controls';

class Search extends SetupSearch {

	initialForm() {
		return {
			searchText: "",
			emailCategory: ""
		}
	}

	ready = () => {
		this.focusControl && this.focusControl.focus();
	}

	searchLoader = () => {
		return {
			url: API.Search.url('/suggest'),
			params: { type: 'emailTemplates' }
		}
	}

	renderForm() {
		return (
			<Row>
				<Col md={4}>
					<SearchBox
						name="searchText"
						placeholder="Search Email Templates..."
						loader={this.searchLoader}
						ref={(c) => { this.focusControl = c }} />
				</Col>
				<Col md={3}>
					<EmailCategoryCombo 
						name="emailCategory" 
						onChange={this.search} 
						placeholder="Email Category" clearable/>
				</Col>
			</Row>
		)
	}
}

export default Search;


// WEBPACK FOOTER //
// ./src/areas/admin/emailingTemplateSetup/Search.js